import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import { Container } from "reactstrap";

class Dashboard extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>خانه من | پیش خوان</title>
          </MetaTags>
          <Container fluid>
            <h3>پیش خوان</h3>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default Dashboard;
